import { useAuth } from '../context/AuthContext';

const FRONTEND_PERMISSIONS = {
  owner: ['*'],
  admin: ['*'],
  manager: [
    'pos:use',
    'inventory:view',
    'inventory:cost:view',
    'inventory:write',
    'inventory:adjust',
    'inventory:activity:view',
    'purchases:view',
    'purchases:manage',
    'sales:view',
    'sales:create',
    'sales:update',
    'sales:return',
    'sales:delete',
    'customers:view',
    'customers:write',
    'reports:view',
    'reports:generate',
    'staff:view',
    'staff:write',
    'analytics:view',
    'finances:view',
    'finances:write',
    'ai:view',
    'debt:view',
    'debt:write',
    'crm:view',
    'crm:write',
  ],
  cashier: [
    'pos:use',
    'inventory:view',
    'sales:view',
    'sales:create',
    'customers:view',
    'customers:write',
    'attendance:own',
  ],
  staff: [
    'pos:use',
    'inventory:view',
    'sales:view',
    'sales:create',
    'customers:view',
    'customers:write',
    'attendance:own',
    'payslip:own',
  ],
};

export function usePermissions() {
  const { user } = useAuth();
  const role = user?.role || 'staff';
  const perms = FRONTEND_PERMISSIONS[role] || [];
  const can = (permission) => {
    if (!permission) return true;
    if (perms.includes('*') || perms.includes(permission)) return true;
    const scope = String(permission).split(':')[0];
    return perms.includes(`${scope}:*`);
  };
  return { can, role };
}
